import React from 'react';
import './tripPlanTree.css'; // Import the CSS file

// Modal for displaying event media (attachment preview/download)
function EventMediaModal({ open, onClose, mediaUrl, filename }) {
  const [imgError, setImgError] = React.useState(false);
  const [iframeError, setIframeError] = React.useState(false);
  // Drag state
  const [dragging, setDragging] = React.useState(false);
  const [offset, setOffset] = React.useState({ x: 0, y: 0 });
  const [position, setPosition] = React.useState({ x: 0, y: 0 });
  const modalRef = React.useRef(null);

  React.useEffect(() => {
    // Reset position when modal opens
    if (open) setPosition({ x: 0, y: 0 });
  }, [open]);

  const onMouseDown = (e) => {
    if (e.button !== 0) return; // Only left mouse
    setDragging(true);
    const rect = modalRef.current.getBoundingClientRect();
    setOffset({ x: e.clientX - rect.left, y: e.clientY - rect.top });
    e.preventDefault();
  };
  React.useEffect(() => {
    if (!dragging) return;
    const onMouseMove = (e) => {
      setPosition({ x: e.clientX - offset.x, y: e.clientY - offset.y });
    };
    const onMouseUp = () => setDragging(false);
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };
  }, [dragging, offset]);

  if (!open) return null;
  // Helper to check if file is an image
  const isImage = (url) => {
    return /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(url.split('?')[0]);
  };
  // Helper to check if file is a PDF
  const isPDF = (url) => {
    return /\.pdf$/i.test(url.split('?')[0]);
  };
  // Helper to check if file is a video
  const isVideo = (url) => {
    return /\.(mp4|webm|ogg|mov)$/i.test(url.split('?')[0]);
  };
  // Helper to check if file is audio
  const isAudio = (url) => {
    return /\.(mp3|wav|ogg|m4a)$/i.test(url.split('?')[0]);
  };
  return (
    <div className="event-media-modal-overlay">
      <div
        className="event-media-modal-content"
        ref={modalRef}
        style={{
          left: position.x ? position.x : undefined,
          top: position.y ? position.y : undefined,
          position: position.x || position.y ? 'fixed' : undefined,
          cursor: dragging ? 'grabbing' : undefined,
        }}
      >
        <button onClick={onClose} title="Close" className="event-media-modal-close-btn">
          <span className="event-media-modal-close-x">×</span>
        </button>
        <div
          className="event-media-modal-title event-media-modal-draggable"
          onMouseDown={onMouseDown}
          style={{ cursor: 'grab', userSelect: 'none' }}
        >
          {filename ? filename.split(/[/\\]/).pop() : ''}
        </div>
        <div className="event-media-modal-preview">
          {isImage(mediaUrl) && !imgError ? (
            <img src={mediaUrl} alt={filename} className="event-media-modal-img" crossOrigin="use-credentials" onError={() => setImgError(true)} />
          ) : isPDF(mediaUrl) && !iframeError ? (
            <iframe src={mediaUrl} title={filename} className="event-media-modal-iframe" crossOrigin="use-credentials" onError={() => setIframeError(true)} />
          ) : isVideo(mediaUrl) ? (
            <video src={mediaUrl} controls className="event-media-modal-video" crossOrigin="use-credentials" />
          ) : isAudio(mediaUrl) ? (
            <audio src={mediaUrl} controls className="event-media-modal-audio" crossOrigin="use-credentials" />
          ) : (
            <a href={mediaUrl} target="_blank" rel="noopener noreferrer" className="event-media-modal-download">Download/View Attachment</a>
          )}
        </div>
      </div>
    </div>
  );
}

export default EventMediaModal;
